/* eslint-disable prettier/prettier */
export enum SORTDIRECTIONS {
  ASCENDING = "asc",
  DESCENDING = "desc",
}

export enum NUMBERS {
  ZERO = 0,
  ONE = 1,
  TWO = 2,
  THREE = 3,
  FOUR = 4,
  FIVE = 5,
  SIX = 6,
  SEVEN = 7,
  EIGHT = 8,
  NINE = 9,
  TEN = 10,
  NEGATIVE = -1,
}

export enum COLUMNTITLES {
  VIEWARCHIVE = "View Archive",
  ARCHIVED = "Archived",
  CLIMATECHANGE = "Climate Change",
  ANIMALWELFARE = "Animal Welfare",
  PACKAGING = "Packaging",
  HUMANRIGHTS = "Human Rights",
  ENVIRONMENT = "Environment",
  TRANSPARENCY = "Transparency",
  OVERALL = "Overall",
  RISK_STATUS_THRESHOLD = "Risk Status Threshold",
}

export enum SEARCH_LABELS {
  COUNTRYREGION = "Country/Region",
  VENDOR_NUMBER = "Vendor #",
  VENDOR_NAME = "Vendor Name",
  ITEM_NUMBER = "Item #",
  ITEM_DESCRIPTION = "Item Description",
  COMMODITY = "Commodity",
}

export enum PAGE_TITLES {
  HOME = "Home",
  ADMINPORTAL = "Admin",
}

export enum FOOTCONTENT {
  CA_NOTICE = "CA Notice",
  COOKIE_SETTINGS = "Cookie Settings",
  PRIVACY_CHOICES = "Your Privacy Choices",
  PRIVACY_RIGHTS = "Your Privacy Rights",
  SITE_MAP = "Site Map",
  TERMS = "Terms and Conditions",
}

export enum LogLevel {
    ERROR = "ERROR",
    WARNING = "WARNING",
    INFO = "INFO",
    FINE = "FINE",
    DEBUG = "DEBUG",
  }